import PropTypes from 'prop-types';
import React from 'react';
import { convertToHexString } from '../utils';

/**
 * label should have height of "32 points"
 * label should have height "0 points" (hidden) when NULL
 */
const Label = ({
  value: _value = '',
  className: _className = '',
  color: _color = null
}) => {
  const showLabel = typeof _value === 'string';
  const divStyles = {
    padding: '6.5px 0',
    minHeight: '32px'
  };
  const pStyles = {
    margin: '0',
    whiteSpace: 'pre-line'
  };
  if (_color) {
    pStyles.color = convertToHexString(_color);
  }
  return showLabel ? /*#__PURE__*/React.createElement("div", {
    className: `t-label ${_className}`,
    style: divStyles
  }, /*#__PURE__*/React.createElement("p", {
    style: pStyles
  }, _value)) : null;
};
Label.propTypes = {
  className: PropTypes.string,
  value: PropTypes.string,
  color: PropTypes.shape({
    red: PropTypes.number,
    green: PropTypes.number,
    blue: PropTypes.number
  })
};
export default Label;